import styled from 'styled-components';

const Reply = styled.div`
	position: relative;
	display: flex;
	padding: 0 0 0 16px;
`;

export default Reply;